import { useEffect, useRef } from 'react';
import { Card, CardHeader, CardContent, IconButton, Typography, Tooltip, CardActions } from "@mui/material"
import GirdCellLoaderAminationData from "../shared/loaders/grid-cell-loader.json";
import AnimateLoader from "../shared/loaders/animate-loader.component";
import { InformationIcon } from '../../icon';

interface Props {
    title: string;
    avatar?: any;
    body: string;
    tooltip?: string;
    showToolTip?: boolean;
    IsMobileDevice?: boolean;
    IsTeamsApp?: boolean;
    ShowLoader?: boolean;
    CardColor?: string;
}

const DashboardCard = (props: Props) => {
    const element = useRef<any>()

    useEffect(() => {
        element.current.parentElement.className = `${element.current.parentElement?.className} tool-icon-center`;
    }, [])

    return (
        <Card className={`box-shadow-none br-4 w-p-100 ${props.CardColor} ${props.IsMobileDevice ? 'h-p-65 pt-1 pb-3 d-flex flex-direction justify-around' : 'h-p-100'}`}>
            <CardHeader className={`${props.IsMobileDevice ? "px-1 py-0" : "px-2 pt-2 p-0"} `}
                action={<div ref={element} className="d-flex ">
                    {props.IsMobileDevice ? props.avatar :
                        props.showToolTip &&
                        <Tooltip title={props.tooltip} placement="bottom-end" enterTouchDelay={0}>
                            <IconButton size="small" className={'p-2'}>
                                <InformationIcon />
                            </IconButton>
                        </Tooltip>
                    }</div>
                }
                title={props.IsMobileDevice ? props.title : props.avatar}
                classes={{ title: `${props.IsMobileDevice && "h4 color-lite-dark-white py-2 ml-1"}` }}
            />
            <CardContent className={`d-flex ${props.IsMobileDevice ? '' : 'py-3'} color-lite-dark-white`} style={{ color: "white" }}>
                {!!props.ShowLoader ? <AnimateLoader LoaderAnimation={GirdCellLoaderAminationData} className={props.IsMobileDevice ? "w-6 h-3" : ""} />
                    :
                    <span className={`${props.IsMobileDevice ? "h3-semibold color-lite-dark-white mb-1" : "h3-bold color-lite-dark-white"}`}>{props.CardColor === "bg-dashboard-phone" ? (<div style={{ fontSize: '13px' }}>{props.body}</div>) : (props.body)}</span>}
            </CardContent>
            {!props.IsMobileDevice &&
                <CardActions className={`px-2 pb-2 p-0 d-block ${props.IsMobileDevice ? 'pt-1' : 'pt-1'}`}>
                    <Typography className={`${props.IsMobileDevice ? 'h4' : 'h4-regular'}  color-lite-dark-white`} style={{ color: "white" }}>{props.title}</Typography>
                    <div className={"mt-1 dashboard-line m-0 mb-2 w-6"}></div>
                </CardActions>
            }
        </Card>
    )

}
export default DashboardCard;
